import React from "react";

export default function ComparisonCard({
  title,
  description,
  backgroundColor,
  textColor,
  iconSrc,
  img,
}) {
  return (
    <div
      className={`p-6 w-[500px] h-[300px] rounded-lg shadow-md ${textColor} dark:text-sidom-light ${backgroundColor} relative`}
    >
      <div className="flex items-center mb-4">
        {iconSrc && (
          <div className="absolute -top-8 right-6  rounded-full shadow-lg p-2 w-40 h-16 flex items-center justify-center">
            <img src={iconSrc} alt="Icon" className="w-30 h-30" />
          </div>
        )}
        <div className="flex flex-col gap-3">
          {img && (
            <div className="w-full">
              <img src={img} alt="img" className="w-25 h-10" />
            </div>
          )}

          <h3 className="fonte ">{title}</h3>
        </div>
      </div>
      <p className="">{description}</p>
    </div>
  );
}
